module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.loggedIn) ? _c('div', {
    staticClass: "user-actions pull-right"
  }, [_c('span', [_vm._v("Welcome back " + _vm._s(_vm.username))]), _c('a', {
    staticClass: "fancy-link",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("logout")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07511f51!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserActions.vue
// module id = 403
// module chunks = 2